import Marquee from "react-fast-marquee";
import { Asterisk } from "@phosphor-icons/react";

const ITEMS = [
    "20 FT Containers",
    "40 FT Containers",
    "Heavy Machinery",
    "Freight Forwarding",
    "ODC & Project Cargo",
    "Pan India Network",
];

export default function EditorialMarquee() {
    return (
        <div className="border-y border-white/10 py-7 md:py-9" data-testid="editorial-marquee">
            <Marquee speed={32} gradient={false} pauseOnHover>
                {ITEMS.map((item) => (
                    <span key={item} className="mx-6 flex items-center gap-12 md:mx-10">
                        <span className="whitespace-nowrap font-display text-4xl uppercase tracking-wide text-white/85 md:text-6xl">
                            {item}
                        </span>
                        <Asterisk size={36} weight="bold" className="shrink-0 text-blaze md:size-12" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
